"use client"

import Intro from "./Intro/Intro"
import Speakers from "../Speakers/Speakers"
import About from "./About/About"
import Place from "./Place/Place"
import AboutPlatform from "./AboutPlatform/AboutPlatform"
import ReadingRoomBlock from "../ReadingRoom/ReadingRoom"
import Gallery from "./Gallery/Gallery"
import CallToAction from "./CallToAction/CallToAction"
import { isPastEvent } from "@/utils/datehelpers"
import { usePathname } from "next/navigation"
import ROOMDATA from "@/data/readingRoom/poland2025"
import ROOMDATADUBAI from "@/data/readingRoom/dubai2025"

export default function Event({
  item,
  videos,
  fullVideo,
  hasLangSelector,
  readingRoom,
  hasStaticReadingRoom,
}) {
  const pathname = usePathname()

  return (
    <>
      <Intro item={item} hasLangSelector={hasLangSelector}></Intro>
      {item.participants && item.participants.length ? (
        <Speakers speakers={item.participants}></Speakers>
      ) : null}
      <About item={item} videos={videos}></About>
      {isPastEvent(item.date_time, item.time_zone) &&
        item.gallery.length > 0 && <Gallery items={item.gallery}></Gallery>}
      {item.place &&
        item.type === "offline" &&
        !isPastEvent(item.date_time, item.time_zone) && (
          <Place item={item}></Place>
        )}
      {item.place &&
        item.type === "offline" &&
        !isPastEvent(item.date_time, item.time_zone) && <CallToAction />}
      <AboutPlatform></AboutPlatform>

      {pathname.includes("poland2025") && (
        <ReadingRoomBlock
          title={ROOMDATA.title}
          isEvent
          items={ROOMDATA.items}
        />
      )}

      {pathname.includes("dubai2025") && (
        <ReadingRoomBlock
          title={ROOMDATADUBAI.title}
          isEvent
          items={ROOMDATADUBAI.items}
        />
      )}

      {/* {readingRoom &&
        readingRoom.some(
          (child) => Array.isArray(child.items) && child.items.length > 0
        ) && <ReadingRoomBlock hasDesc isEvent items={readingRoom} />} */}
    </>
  )
}
